import { readItems } from '@directus/sdk';
import type { CollectionType, QueryItem, RegularCollections } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import type { Schema } from '../../../../types/DirectusSchema';
import { queryKeysFactory } from '../../lib/queryKeysFactory.ts';
import { directusClient } from '../../services/directusClient/directusClient.ts';

export const useDirectusCollectionList = <
  Collection extends RegularCollections<Schema>,
  TQuery extends QueryItem<Schema, CollectionType<Schema, Collection>>,
>(
  collection: Collection,
  query?: TQuery,
) => {
  return useQuery({
    staleTime: 60 * (60 * 1000), // 60 mins
    queryKey: queryKeysFactory(collection).detail(JSON.stringify(query)),
    queryFn: async () => directusClient.request(readItems(collection, query)),
  });
};
